import React from 'react';
import {
  View,
  Text,
  StyleSheet,
  Modal,
  TouchableOpacity,
  ScrollView,
  Dimensions,
} from 'react-native';

type ModalProps = {
  visible: boolean;
  onClose: () => void;
};

export default function UsageScrollOnboardingModal({
  visible,
  onClose,
}: ModalProps) {
  const DEFAULT_ANIM_HEIGHT = 320;
  const title = '今後のお支払い金額をひと目でチェック';
  const content =
    'グラフをスクロールすると、今後お支払いいただく予定の金額がひと目でチェックできます。お金をしっかり管理しながら、かしこくお買い物をお楽しみください。';
  const npayVideo = require('assets/videos/usage-scroll.mp4');

  const animHeight =
    Dimensions.get('window').height * 0.5 < DEFAULT_ANIM_HEIGHT
      ? Dimensions.get('window').height * 0.5
      : DEFAULT_ANIM_HEIGHT;
  const scrollHeight = Dimensions.get('window').height * 0.25;

  return (
    <Modal visible={visible} transparent>
      <View style={styles.modal}>
        <View
          style={[
            styles.animSection,
            {
              height: animHeight,
            },
          ]}
        >
          <video
            style={{
              objectFit: 'cover',
              width: '100%',
              height: 320,
              ...styles.backgroundVideo,
            }}
            autoPlay
            loop
            preload="true"
            playsInline
            muted
          >
            <source src={npayVideo} type="video/mp4" />
            Sorry, your browser doesn't support videos.
          </video>
        </View>
        <View style={styles.contentSection}>
          <View style={styles.textContainer}>
            <ScrollView
              style={{
                maxHeight: scrollHeight,
              }}
            >
              <Text style={styles.title}>{title}</Text>
              <Text style={styles.content}>{content}</Text>
            </ScrollView>
          </View>
          <View style={styles.footer}>
            <TouchableOpacity onPress={onClose}>
              <Text style={styles.close}>閉じる</Text>
            </TouchableOpacity>
          </View>
        </View>
      </View>
    </Modal>
  );
}

const styles = StyleSheet.create({
  modal: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    justifyContent: 'center',
    paddingHorizontal: 16,
    alignItems: 'center',
  },
  animSection: {
    borderTopStartRadius: 16,
    borderTopEndRadius: 16,
    width: '100%',
    backgroundColor: '#fff',
    height: 320,
    alignItems: 'center',
    justifyContent: 'flex-start',
    overflow: 'hidden',
    maxWidth: 344,
  },
  contentSection: {
    borderBottomEndRadius: 16,
    borderBottomStartRadius: 16,
    backgroundColor: '#A6D2E4',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'flex-start',
    maxWidth: 344,
  },
  textContainer: {
    width: '100%',
    paddingVertical: 24,
    paddingHorizontal: 16,
  },
  title: {
    fontSize: 16,
    fontWeight: 'bold',
    lineHeight: 24,
    color: '#2a2e32',
    width: '100%',
  },
  content: {
    fontSize: 13,
    fontWeight: '300',
    lineHeight: 16,
    color: '#2a2e32',
    width: '100%',
    marginVertical: 16,
  },
  footer: {
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    paddingHorizontal: 16,
    paddingBottom: 24,
  },
  close: {
    fontSize: 13,
    fontWeight: 'bold',
    lineHeight: 16,
    color: '#2a2e32',
  },
  backgroundVideo: {
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
  },
});
